export default "__VITE_ASSET__15883c07__"